import { useState } from 'react'
import { FullScreenModal } from '../../utility/FullScreenModal'
import { SystemSS } from '../../components/SystemSS'

export const ButtleFlowStep3 = () => {
    const [showModal, setShowModal] = useState(false)
    const [modalContent, setModalContent] = useState({ contentType: '', category: '', index: 0 })
    const handleOpenModal = (contentType, category, index, maxIndex) => {
        setModalContent({ contentType, category, index, maxIndex })
        setShowModal(true)
    }
    const handleCloseModal = () => {
        setModalContent({ contentType: '', category: '', index: 0 })
        setShowModal(false)
    }
    return (
        <section>
            <div className='flex justify-center '>
                <img
                    className=''
                    alt='gameflow button'
                    src={`${process.env.PUBLIC_URL}/images/system/system-header-step3.webp`}
                />
            </div>{' '}
            <div className='flex justify-center mt-12'>
                <img
                    className=''
                    alt='One more'
                    src={`${process.env.PUBLIC_URL}/images/system/system-header-skills.webp`}
                />
            </div>{' '}
            <div className='text-pbnavy font-kiwi font-bold text-sub md:text-base text-shadow-white w-full px-4 md:px-0 md:w-4/5 mx-auto mt-12'>
                <p className=' '>
                    You can <span className='text-pborange'>attack</span> either barehanded or with an equipped item. By
                    selecting <span className='text-pborange'>Skills</span>, a list of skills will be displayed. In
                    addition to attack skills, <span className='text-pborange'>healing skills</span> are also accessible
                    from this menu.
                </p>{' '}
                <SystemSS
                    mediaItems={[
                        {
                            modalId: 'flow-3',
                            index: 1,
                        },
                        {
                            modalId: 'flow-3',
                            index: 2,
                        },
                    ]}
                    handleOpenModal={handleOpenModal}
                    description='The characters standing inside the AoE area are the targets of the skill. Both enemies and
                        allies will be affected if they are inside the area, so be careful!'
                />{' '}
                <p className=' '>
                    In addition to weapons, the{' '}
                    <span className='text-pborange'>grass and trees on the maps can also be equipped</span> by
                    characters! <span className='text-pborange'>Their skills will differ</span> depending on what is
                    equipped.
                </p>{' '}
                <SystemSS
                    mediaItems={[
                        {
                            modalId: 'flow-3',
                            index: 3,
                        },
                    ]}
                    handleOpenModal={handleOpenModal}
                    description=' This may seem like a simple blade of grass, but it has a powerful skill that deals more damage
                        than when a character is barehanded!'
                />{' '}
                <p className=' '>
                    Before you execute an attack on an enemy, the <span className='text-pborange'>predicted damage</span> will be displayed. Check out the
                    predicted number and keep an open mind about the best way to attack. The attack with the most damage
                    may not always be what you think!
                </p>{' '}
                <SystemSS
                    mediaItems={[
                        {
                            modalId: 'flow-3',
                            index: 4,
                        },
                    ]}
                    handleOpenModal={handleOpenModal}
                    description=' You can inflict massive damage by attacking using an element the enemy is weak against or other
                        techniques!'
                />{' '}
            </div>
            <FullScreenModal
                showModal={showModal}
                modalContent={modalContent}
                setModalImage
                handleCloseModal={handleCloseModal}
                setModalContent={setModalContent}
                maxIndex={4}
            />
        </section>
    )
}
